import { useLingui } from '@lingui/react/macro';
import { type Icon, Moon, Sun1 } from 'iconsax-reactjs';
import type { FC } from 'react';
import { cn } from '@/shared/react';
import { Select, type SelectOption, type SelectProps } from '@/shared/Select';
import { useIsDark } from '../theme/theme';
import { type Settings, useSettings } from './api';

export const ThemeSelect: FC<
  Omit<
    SelectProps<false, Settings['theme']>,
    'value' | 'onChange' | 'options'
  > & {
    mini?: boolean;
  }
> = ({ mini, ...props }) => {
  const { t } = useLingui();
  const [settings, setSettings] = useSettings();
  const isDark = useIsDark();
  const label =
    (
      text: string,
      Icon: Icon,
    ): SelectOption<Settings['theme'] | null>['label'] =>
    (target) =>
      target === 'option' ? (
        <div className="text-center min-w-16">{text}</div>
      ) : (
        <>
          <Icon size={18} className={cn(mini ? 'mx-auto' : 'me-1')} />
          {!mini && text}
        </>
      );

  return (
    <Select
      value={settings.theme}
      onChange={(v) => setSettings({ theme: v || 'auto' })}
      options={
        [
          {
            key: 'auto',
            value: 'auto',
            label: label(t`Auto`, isDark ? Moon : Sun1),
          },
          {
            key: 'light',
            value: 'light',
            label: label(t`Light`, Sun1),
          },
          {
            key: 'dark',
            value: 'dark',
            label: label(t`Dark`, Moon),
          },
        ] as const
      }
      aria-label="Theme"
      {...props}
    />
  );
};
